<template>
  <div class="px-1">
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :egressProfileId="egress_profile_id"
      :showEgressProfile="true"
      :showMatrix2="true"
      :showMatrix3="true"
      :showMatrix4="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
    ></NavigationBreadcrumb>
    <h4 class="mt-3">
      {{ $getVisibleNames("manual.matriz_1", false, "Matriz 1") }}:
      {{
        egressProfile
          ? egressProfileCycleId.length > 1
            ? String(
                $t("matrix1.matrix1View.progressionOf") +
                  " " +
                  $getVisibleNames("mesh.competence", true, "Competencias") +
                  " " +
                  $t("matrix1.matrix1View.by") +
                  " " +
                  $getVisibleNames("mesh.cycle", true, "Ciclos Formativos")
              )
            : String($getVisibleNames("mesh.competence", true, "Competencias"))
          : String($getVisibleNames("mesh.competence", true, "Competencias"))
      }}
      <span v-if="career"
        >{{ " " + $t("matrix1.matrix1View.of") + " " + career.name }}
      </span>
    </h4>
    <br />
    <div class="d-flex mb-1 noprint">
      <b-button
        v-if="institution && institution.show_base_ra"
        @click="redirectToMatrix1PerCycle(egress_profile_id)"
        size="sm"
        class="ml-auto mr-2"
      >
        <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon
        >{{ $t("matrix1.matrix1View.viewOf") }}
        {{ $getVisibleNames("manual.matriz_1", false, "Matriz 1") }}</b-button
      >
      <GenericButtonDownload
        :class="{
          'ml-auto': institution && !institution.show_base_ra,
        }"
        v-if="egressProfile && egressProfileCycleId.length > 0"
        :tooltip_text="
          $t('toolbar.reports.reportCompetenceXlsx', {
            competences: $getVisibleNames(
              'mesh.competence',
              true,
              'Competencias'
            ),
          })
        "
        :click_button="downloadExcel"
        :disabled_button="disabled_button_excel"
        :icon_excel="true"
      ></GenericButtonDownload>
    </div>
    <Matrix1
      :egress_profile_id="egress_profile_id"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
    ></Matrix1>
    <div
      v-if="!(institution && institution.internal_use_id == 'duoc.cl')"
      class="mb-5"
    >
      <template v-if="egress_profile_id">
        <EgressProfileCompetenceMention
          style="margin-bottom: 10em"
          v-if="
            profile_competences_mention.filter(
              (x) => x.egress_profile == egress_profile_id
            ).length > 0 || allows_crud
          "
          :allows_crud="allows_crud"
          :can_update="can_update"
          :can_delete="can_delete"
          :egress_profile_id="egress_profile_id"
        ></EgressProfileCompetenceMention>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as names from "@/store/names";
import { showLoadingAlert, downloadFileFromResponse } from "@/utils/utils";
export default {
  name: "Matrix1View",
  components: {
    Matrix1: () => import("./Matrix1"),
    EgressProfileCompetenceMention: () =>
      import("@/components/mesh/EgressProfile/EgressProfileCompetenceMention"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      egress_profile_id: Number(this.$route.params.egress_profile_id),
      disabled_button_excel: false,
      // printing: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      profile_cycles: names.PROFILE_CYCLES,
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      institution: "getInstitution",
      profile_competences_mention: names.PROFILE_COMPETENCES_MENTION,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
          to: "/careers",
        },
        {
          text: this.$getVisibleNames("manual.matriz_1", false, "Matriz 1"),
          dropdownOptions: [
            "showEgressProfile",
            "showMatrix2",
            "showMatrix3",
            "showMatrix4",
            "showStudyPlan",
            "showCurricularMesh",
          ],
        },
      ];
    },
    egressProfile() {
      if (!this.egress_profile_id) return [];
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "change",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "change",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    can_delete() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "delete",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "delete",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    allows_crud() {
      if (
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        (this.can_update || this.can_delete)
      ) {
        const has_permission = this.$hasPermissions(
          "mesh.change_egressprofile"
        );
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else {
          return false;
        }
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
    egressProfileCycleId() {
      if (!this.egress_profile_id) return [];
      let list = [];
      this.profile_cycles.forEach((x) => {
        if (x.egress_profile == this.egress_profile_id) list.push(x.cycle);
      });
      return list;
    },
  },
  methods: {
    redirectToMatrix1PerCycle(egress_profile_id) {
      // this.$router.push({
      // let route_data = this.$router.resolve({
      this.$router.push({
        name: "Matrix1PerCycleView",
        params: { egress_profile_id: egress_profile_id },
      });
      // window.open(route_data.href, "_blank");
    },
    downloadExcel() {
      this.disabled_button_excel = true;
      const payload = {
        egress_profile_id: this.egress_profile_id,
      };
      const url = `/mesh/matrix1_excel/`;

      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );

      this.$restful
        .Post(url, payload, {
          responseType: "blob",
        })
        .then((response) => {
          this.$swal.close();
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
              }
            );
          } else {
            this.disabled_button_excel = false;
          }
        })
        .catch(() => {
          this.$swal.close();
          this.disabled_button_excel = false;
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
  },
  mounted() {
    if (
      this.user &&
      this.user.student_card &&
      this.user.group_names.includes("ESTUDIANTES") &&
      this.user.student_card.egress_profile != this.egress_profile_id
    ) {
      this.$router.push({
        name: "Page403",
      });
    }
    if (this.user && this.user.group_names.includes("PROFESORES")) {
      this.$restful
        .Get(`/mesh/fully_visible_professor_egress_profiles/`)
        .then((response) => {
          if (!response.includes(this.egress_profile_id)) {
            this.$router.push({
              name: "Page403",
            });
          }
        });
    }
    this.$store.commit(names.MUTATE_PRINT_ORIENTATION, true);
    this.$store.commit(names.MUTATE_PRINT_ZOOM_SCALE, 1);
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
    this.$store.commit(names.RESET_PRINT_ZOOM_SCALE);
    this.$store.commit(names.RESET_PRINT_ORIENTATION);
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
  },
  created() {
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_RA_BASES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_COMPETENCES, this.egress_profile_id);
    this.$store.dispatch(names.FETCH_PROFILE_CYCLES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((response) => {
        if (!response.is_closed && this.can_update)
          this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
        this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
          visible_intelligence_options: [1],
          disabled_selected_intelligence_option: true,
          disabled_selected_egress_profile: true,
        });
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          egress_profile_id: this.egress_profile_id,
          intelligence_option: 1,
        });
        this.$store.commit(
          names.MUTATE_TITLE_OF_THE_PRINT,
          `${this.$getVisibleNames("manual.matriz_1", false, "Matriz 1")} - ${
            response.name
          }`
        );
        this.$store.dispatch(names.FETCH_CAREER, response.career);
      });
    this.$store.dispatch(names.FETCH_COMPETENCE_TYPES);
    this.$store.dispatch(names.FETCH_TAXONOMIES);
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES_MENTION, {
      egress_profile_id: this.egress_profile_id,
    });
  },
};
</script>

<style scoped>
th {
  background-color: var(--primary-color);
  color: var(--primary-font-color);
}
table,
th,
td {
  border: 1px solid black;
  position: relative;
}
div.float-button {
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
}
.btn-matrix1-per-cycle {
  display: flex;
}
</style>